import { DECOR_HEADING, PRO_HEADING, SBOTD_HEADING } from '../constants';

export const noop = () => { };

/**
 * @param {string} promoType sbotd | pro | decor
 * @returns {string} headingTitle custom heading for promo
 */
export const getPromoHeading = (promoType) => {
  let headingTitle;
  switch (promoType) {
  case 'sbotd':
    headingTitle = SBOTD_HEADING;
    break;
  case 'pro':
    headingTitle = PRO_HEADING;
    break;
  case 'decor':
    headingTitle = DECOR_HEADING;
    break;
  default:
    headingTitle = '';
    break;
  }
  return headingTitle;
};
